import { createContext, useEffect, useReducer } from "react";
import users from "../services/users.json";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const ACTIONS = {
    CALL: "call",
    SUCCESS: "success",
  };

  const authReducer = (state, action) => {
    switch (action.type) {
      case ACTIONS.CALL: {
        return { ...state, loading: true };
      }
      case ACTIONS.SUCCESS: {
        return { ...state, loading: false, ...action.data };
      }
      default: {
        return;
      }
    }
  };

  const [auth, authDispatch] = useReducer(authReducer, {
    loading: true,
    isAuthenticated: false,
  });

  useEffect(() => {
    if (auth.loading) {
      const isAuthenticated = JSON.parse(
        window.sessionStorage.getItem("nhPortfolioAuth")
      );
      if (isAuthenticated === null) {
        authDispatch({
          type: ACTIONS.SUCCESS,
          data: { isAuthenticated: false },
        });
      } else {
        authDispatch({
          type: ACTIONS.SUCCESS,
          data: { isAuthenticated: true },
        });
      }
    }
  }, [auth.loading]);

  const login = async ({ password }) => {
    for (const user in users) {
      if (password === users[user]) {
        window.sessionStorage.setItem("nhPortfolioAuth", JSON.stringify(true));
        authDispatch({ type: ACTIONS.CALL });
      } else {
        return false;
      }
    }
  };

  const logout = () => {
    window.sessionStorage.clear();
    authDispatch({ type: ACTIONS.CALL });
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
